module.exports = __webpack_public_path__ + "static/media/banner-exercises.ed18052e.png";